import { styled } from '@linaria/react';
import { ResponsiveContainer, Tooltip, Treemap } from 'recharts';
import { ContentPlaceholder } from '../../../../../components/content-placeholder/content-placeholder';
import { setActivePanel, setSelectedInitiative } from '../../../../../store/strategy-store/strategy-store.actions';
import { Panel } from '../../../../../store/strategy-store/strategy-store.type';
import { baseWhite } from '../../../../../styles/design-tokens';
import { useFilteredInitiatives, useFiltersApplied } from '../../../strategy.hooks';
import { TreeMapDataType } from '../main-section.type';
import { TreeMapContent } from './tree-map-content';
import { TreeMapTooltip } from './tree-map-tooltip';
import { useTreeMapData } from './tree-map.hooks';

type Props = {
  isLoading: boolean;
};

export const MainSectionTreeMap = ({ isLoading }: Props) => {
  const { treeMapData } = useTreeMapData({ isLoading });
  const { initiatives } = useFilteredInitiatives({ enableSearch: false });
  const filtersApplied = useFiltersApplied();

  const handleTreeMapClick = (data: any) => {
    const payload = data.payload || data;
    if (payload && payload.type === TreeMapDataType.Other) {
      setSelectedInitiative(null);
      setActivePanel(Panel.OtherInitiatives);
    } else if (payload && payload.initiativeId) {
      // Find the initiative by ID
      const initiative = initiatives.find((item) => item.id === payload.initiativeId);
      if (initiative) {
        // Set the selected initiative (which will also open the side panel)
        setSelectedInitiative(initiative);
      }
    }
  };

  if (!filtersApplied) {
    return <ContentPlaceholder noFiltersApplied />;
  }

  if (isLoading || treeMapData.length === 0) {
    return <ContentPlaceholder />;
  }

  return (
    <StyledResponsiveContainer>
      <Treemap
        data={treeMapData}
        dataKey="size"
        aspectRatio={1}
        stroke={baseWhite}
        isAnimationActive={false}
        content={<TreeMapContent />}
        onClick={handleTreeMapClick}
      >
        <Tooltip content={<TreeMapTooltip />} />
      </Treemap>
    </StyledResponsiveContainer>
  );
};

const StyledResponsiveContainer = styled(ResponsiveContainer)`
  .recharts-wrapper {
    position: absolute !important;
  }
`;
